import { render, staticRenderFns } from "./export-started-contract.vue?vue&type=template&id=12bafab6&"
import script from "./export-started-contract.vue?vue&type=script&lang=js&"
export * from "./export-started-contract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports